import React from 'react'

export type PwaTextProps = {
    pwaInstalled: boolean | null,
    notificationEnabled: boolean | null,
};

// eslint-disable-next-line react/display-name
export const PwaText = React.memo((props: PwaTextProps)=> {
   const {
       pwaInstalled,
       notificationEnabled,
   } = props;

   return <React.Fragment>
       { (!pwaInstalled && !notificationEnabled) &&  'Be the first to know about our offers! Install our application and enable notifications in a few clicks.'}
       { (pwaInstalled && !notificationEnabled) &&  'Be the first to know about our offers! Enable notifications in a few clicks.'}
       { (!pwaInstalled && notificationEnabled) &&  'Be the first to know about our offers! Install our application in a few clicks.'}
   </React.Fragment>;


});
